import { useEffect, useRef } from "react";
import { useBackend } from "../backend/BackendProvider";
import { useToast } from "../components/ToastProvider";

const CALENDAR_KEY = "todo-readonly-calendar-events";
const CALENDAR_NOTICE_KEY = "todo-calendar-retirement-notice";
const REMINDER_NOTICE_KEY = "todo-reminder-retirement-notice";

export function FeatureRetirementEngine() {
  const backend = useBackend();
  const { show } = useToast();
  const checked = useRef(false);

  useEffect(() => {
    if (checked.current) return;
    checked.current = true;

    const rawCalendar = localStorage.getItem(CALENDAR_KEY);
    if (rawCalendar) {
      let count = 0;
      try { const parsed = JSON.parse(rawCalendar); count = Array.isArray(parsed) ? parsed.length : 0; } catch { /* invalid retired data is still removed */ }
      localStorage.removeItem(CALENDAR_KEY);
      if (!localStorage.getItem(CALENDAR_NOTICE_KEY)) {
        localStorage.setItem(CALENDAR_NOTICE_KEY, "shown");
        show(`${count} imported calendar ${count === 1 ? "event was" : "events were"} removed from this device. Your original calendar files were not changed.`);
      }
    }

    if (!localStorage.getItem(REMINDER_NOTICE_KEY)) {
      void backend.reminders.list().then((reminders) => {
        if (!reminders.length) return;
        localStorage.setItem(REMINDER_NOTICE_KEY, "shown");
        show("Reminders are no longer active. Existing reminder data remains available in exports.");
      }).catch(() => undefined);
    }
  }, [backend, show]);

  return null;
}
